import React from 'react';
import { Col, Row } from 'reactstrap';
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import cellEditFactory from 'react-bootstrap-table2-editor';
import moment from 'moment';

const CheckoutDisplay = (props) => {
  const { 
    t,
    startTime, endTime, 
    customerDetails, checkoutCustomerColumn,
    gameDetails, checkoutGameColumn, gameTotalPrice, totalGameTime,
    itemDetails, checkoutItemColumn, itemTotalPrice,
    packageDetails, bookedPackageDetailscolumns,
  } = props;

  return (
    <>
      <div>
        <span>{t("Date and Time")}:</span>
      </div>
      <Row>
        <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
          <h6 style={{ color: "#62AEF2" }}>
            {`Start Time: ${moment(startTime).format("YYYY-MM-DD HH:mm")} - End Time: ${endTime ? moment(endTime).format("YYYY-MM-DD HH:mm") : "N/A"}`}
          </h6>
        </div>
      </Row>
      <br />
      <Col lg={8}><h6>{t("Customer Details")}:</h6></Col>
      <Col>
        <ToolkitProvider keyField="_id" columns={checkoutCustomerColumn} data={customerDetails || []}>
          {propst => (
            <div>
              <BootstrapTable {...propst.baseProps} noDataIndication={t("No data to display.")} striped hover condensed />
            </div>
          )}
        </ToolkitProvider>
      </Col>
      <br />
      <Col lg={6}><h6>{t("Game Details")}</h6></Col>
      <Col>
        <ToolkitProvider keyField="_id" columns={checkoutGameColumn} data={gameDetails || []}>
          {propst => (
            <div>
              <BootstrapTable
                {...propst.baseProps}
                noDataIndication={t("No data to display.")}
                cellEdit={cellEditFactory({ mode: "click", blurToSave: true })}
                striped
                hover
                condensed
              />
              <Row>
                <Col lg={12} style={{ display: "flex", gap: "5px", justifyContent: "flex-end" }}>
                    <span>{t("Total Game Time")}:</span>
                  <span style={{ color: "black", fontWeight: "bolder" }}>
                    {`${totalGameTime} minutes`}
                  </span>
                  &nbsp; &nbsp;
                   
                  <span>{t("Game Total Price")}:</span>
                  <span style={{ color: "black", fontWeight: "bolder" }}>
                    {`QR ${gameTotalPrice ? gameTotalPrice : 0}`}
                  </span>
              
                </Col>
              </Row>
            </div>
          )}
        </ToolkitProvider>
      </Col>
      <br />
      <Col lg={6}><h6>{t("Item Details")}:</h6></Col>
      <Col>
        <ToolkitProvider keyField="item_id" columns={checkoutItemColumn} data={itemDetails || []}>
          {propst => (
            <div>
              <BootstrapTable {...propst.baseProps} noDataIndication={t("No data to display.")} striped hover condensed />
              <Row>
                <Col lg={12} style={{ display: "flex", gap: "5px", justifyContent: "flex-end" }}>
                  {(itemTotalPrice > 0) && (
                    <>
                      <span>{t("Item Total Price")}:</span>
                      <span style={{ color: "black", fontWeight: "bolder" }}>
                        {`QR ${itemTotalPrice}`}
                      </span>
                    </>
                  )}
                </Col>
              </Row>
              
            </div>
          )}
        </ToolkitProvider>
      </Col>
      <br />
      <Col lg={6}><h6>{t("Package Details")}:</h6></Col>
      <Col>
        <ToolkitProvider keyField="_id" columns={bookedPackageDetailscolumns} data={packageDetails || []}>
          {propst => (
            <div>
              <BootstrapTable {...propst.baseProps} noDataIndication={t("No data to display.")} striped hover condensed />
            </div>
          )}
        </ToolkitProvider>
      </Col>
    </>
  );
};

export default CheckoutDisplay;
